<template>
	<header class="main-header flex space v-center">
		<div class="branding flex gap-s v-center">
			<a href="https://eccentri.co/"><span class="material-symbols-rounded">home</span></a>
			
			<div class="name">
				<h2 class="large-font">{{ getLocale('configurator') }}</h2>
				<img class="logo" :src="require('./assets/logo.svg')" />
			</div>
		</div>
		
		<div class="localization flex v-center gap-xxs" @click="lang_modal = true">
			<div class="current-language">{{ language }}</div>
			<span class="material-symbols-rounded">language</span>
		</div>
	</header>
	
	<Configurator />
	
	<transition name="fade">
		<div v-if="lang_modal" class="langs-modal" @click.self="lang_modal = false">
			<ul>
				<li :class="{active : language == 'it'}"><a title="language" href="https://eccentri.co/customizer">IT</a></li>
				<li :class="{active : language == 'en'}"><a title="language" href="https://eccentri.co/customizer/en/">EN</a></li>
				<li :class="{active : language == 'fr'}"><a title="language" href="https://eccentri.co/customizer/fr/">FR</a></li>
				<li :class="{active : language == 'de'}"><a title="language" href="https://eccentri.co/customizer/de/">DE</a></li>
			</ul>
		</div>
	</transition>
	
	<transition name="fade">
		<div v-if="loading" class="loader">
			<div class="loading-dots">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
		</div>
	</transition>
</template>

<script>
	import { commonMixin } from '@/mixins/common.js';
	
	import Configurator from './components/Configurator.vue'
	import Button from './components/Button.vue'
	import { mapState, mapActions } from 'vuex'

	export default {
		name: 'App',
		components: { Configurator, Button },
		mixins: [ commonMixin ],
		data: function () { return {
			lang_modal : false,
			language : typeof language != 'undefined' ? language : 'it',
		}},
		computed: {
			...mapState([ 'loading' ]),
		},
		mounted(){
			this.initialize();
		},
		methods: {
			...mapActions([ 'initialize' ]),
		}
	}
</script>

<style lang="scss">
	@import './assets/styles/base.scss';
	
	.main-header{
		height: 90px;
		padding: 20px;
		padding-bottom: 30px;
		
		.branding{
				
			a{
				width: 40px;
				height: 40px;
				padding: 8px;
				border-radius: 50%;
				background: #E4E2DE;
				color: inherit;
				transition: 0.15s all;
				
				&:hover{
					background: #B6B5B2;
				}
			}
			h2{
				text-transform: uppercase;
				line-height: 20px;
			}
			.logo{
				display: block;
				height: 8.2px;
				margin-top: 5px;
			}
		
			@media (max-width: 399px) {
				gap: 10px;
				
				.name{
					h2{
						font-size: 22.4px;
					}
					.logo{
						height: 6.56px;
					}
				}
			}
		}
		.localization{
			text-transform: uppercase;
			cursor: pointer;
		}
	}
	
	.langs-modal{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,.86);
		z-index: 1000;
		text-align: center;
		padding: 10vw;
		color: #fff;
		
		ul{
			margin: auto;
			display: flex;
			justify-content: center;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			gap: 4vw;
			
			li{
				background-color: transparent;
				transition: background 1s;
				list-style: none;
				
				&:hover{
					background-color: #444;
				}
				
				&.active{
					border-bottom: 2px solid;
				}
				
				a{
					color: #fff;
					height: 10vh;
					line-height: 10vh;
					min-width: 50px;
					display: inline-block;
					font-size: 20px;
					text-decoration: none;
				}
			}
		}
	}
	
	.loader{
		position: fixed;
		left: 0;
		width: 100%;
		top: 0;
		height: 100%;
		z-index: 10;
		background: var(--white);
		
		.loading-dots{
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}
	
</style>
